import { useEffect, useState } from 'react';
import { useGetFormMetadataQuery } from '../../../__generated__/chirp/com/hubspot/portals/platform/app/rpc/FormMetadataRpc.hooks';
export function useResolveEditorVersion({
  formId,
  portalId,
  env,
  editorVersion,
  resolveEditorVersion
}) {
  var _ref;
  const skipQuery = editorVersion != null || resolveEditorVersion != null;
  const {
    data: formMetadata
  } = useGetFormMetadataQuery({
    variables: {
      formGuid: formId
    },
    skip: skipQuery
  });
  const [customResolvedVersion, setCustomResolvedVersion] = useState(null);
  useEffect(() => {
    if (!resolveEditorVersion || editorVersion != null) {
      return;
    }
    let cancelled = false;
    resolveEditorVersion(portalId, formId, env).then(version => {
      if (!cancelled) setCustomResolvedVersion(version);
    }).catch(() => {
      if (!cancelled) setCustomResolvedVersion(1);
    });
    return () => {
      cancelled = true;
    };
  }, [resolveEditorVersion, editorVersion, portalId, formId, env]);
  return (_ref = editorVersion !== null && editorVersion !== void 0 ? editorVersion : customResolvedVersion) !== null && _ref !== void 0 ? _ref : formMetadata ? formMetadata.formCreatedByEditorV2 ? 2 : 1 : null;
}